import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.from";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";

/* eslint-disable no-shadow */
import { useState, useMemo } from 'react';
export default function useSelections(items, defaultSelected) {
  if (defaultSelected === void 0) {
    defaultSelected = [];
  }

  var _useState = useState(defaultSelected),
      selected = _useState[0],
      setSelected = _useState[1];

  var _useMemo = useMemo(function () {
    var selectedSet = new Set(selected);

    var isSelected = function isSelected(item) {
      return selectedSet.has(item);
    };

    var select = function select(item) {
      selectedSet.add(item);
      return setSelected(Array.from(selectedSet));
    };

    var unSelect = function unSelect(item) {
      selectedSet["delete"](item);
      return setSelected(Array.from(selectedSet));
    };

    var toggle = function toggle(item) {
      if (isSelected(item)) {
        unSelect(item);
      } else {
        select(item);
      }
    };

    return {
      selectedSet: selectedSet,
      isSelected: isSelected,
      select: select,
      unSelect: unSelect,
      toggle: toggle
    };
  }, [selected]),
      selectedSet = _useMemo.selectedSet,
      isSelected = _useMemo.isSelected,
      select = _useMemo.select,
      unSelect = _useMemo.unSelect,
      toggle = _useMemo.toggle;

  var _useMemo2 = useMemo(function () {
    var selectAll = function selectAll() {
      items.forEach(function (o) {
        selectedSet.add(o);
      });
      setSelected(Array.from(selectedSet));
    };

    var unSelectAll = function unSelectAll() {
      items.forEach(function (o) {
        selectedSet["delete"](o);
      });
      setSelected(Array.from(selectedSet));
    };

    var noneSelected = items.every(function (o) {
      return !selectedSet.has(o);
    });
    var allSelected = items.every(function (o) {
      return selectedSet.has(o);
    }) && !noneSelected;
    var partiallySelected = !noneSelected && !allSelected;

    var toggleAll = function toggleAll() {
      return allSelected ? unSelectAll() : selectAll();
    };

    return {
      selectAll: selectAll,
      unSelectAll: unSelectAll,
      noneSelected: noneSelected,
      allSelected: allSelected,
      partiallySelected: partiallySelected,
      toggleAll: toggleAll
    };
  }, [selectedSet, items]),
      selectAll = _useMemo2.selectAll,
      unSelectAll = _useMemo2.unSelectAll,
      noneSelected = _useMemo2.noneSelected,
      allSelected = _useMemo2.allSelected,
      partiallySelected = _useMemo2.partiallySelected,
      toggleAll = _useMemo2.toggleAll;

  return {
    selected: selected,
    isSelected: isSelected,
    select: select,
    unSelect: unSelect,
    toggle: toggle,
    selectAll: selectAll,
    unSelectAll: unSelectAll,
    toggleAll: toggleAll,
    allSelected: allSelected,
    noneSelected: noneSelected,
    partiallySelected: partiallySelected,
    setSelected: setSelected
  };
}